
import { useState } from "react";
import styles from "../FieldTypeModal.module.scss";
import { CirclePlusIcon, DeleteIcon, DragIndicatorIcon } from "../../../../../../../assets/icons";
import ToggleButton from "../../../../../../../common/components/toggle-button/ToggleButton";
import { ChoseBoolFiledConfig } from "./shared/ChooseBool";
import Button from "../../../../../../../common/components/xepp/button/Button";
import { LimitNumberAttributeFiledConfig } from "./shared/LimitNumberAttributeConfig";
import { InputWithClearFiledConfig } from "./shared/InputWithClear";
import { Attribute, FieldType } from "../../../../../../../model/service-request/attribute";
import { v4 as uuidv4 } from 'uuid';
import { toast } from "react-toastify";

type Props = {
    onFieldSave: (attr: Attribute) => void
    existingAttribute?: Attribute
}

export const TextDescriptionFieldConfiguration = (props: Props) => {
    const [attribute, setAttribute] = useState<Attribute>({
        id: props.existingAttribute ? props.existingAttribute.id : uuidv4(),
        label: props.existingAttribute ? props.existingAttribute.label : "",
        isRequired: props.existingAttribute ? props.existingAttribute.isRequired : false,
        isEnabled: props.existingAttribute ? props.existingAttribute.isEnabled : true,
        placeholderText: props.existingAttribute ? props.existingAttribute.placeholderText : "",
        isLimited: props.existingAttribute ? props.existingAttribute.isLimited : false,
        maxLengthLimit: props.existingAttribute ? props.existingAttribute.maxLengthLimit : 0,
        fieldType: FieldType.TextDescription,
    });


    const clearFieldName = () =>
        setAttribute({ ...attribute, label: "" });


    return <div className={styles.rightSideBody}>
        <div className={styles.configurationForm}>
            <InputWithClearFiledConfig
                onChange={(val: string) => {
                    setAttribute({ ...attribute, label: val })
                }}
                onClear={clearFieldName}
                value={attribute.label}
                filedLabel="Field Name"
                placeholederText="Enter Field Name"
                multiple={true}
            />

            <ChoseBoolFiledConfig
                onChange={(val: boolean) => {
                    setAttribute({ ...attribute, isRequired: val });
                }
                }
                value={attribute.isRequired}
                option1="Yes"
                option2="No"
                fieldLabel={"Required"}
            />

            <LimitNumberAttributeFiledConfig label={"Max Length"}
                onIsLimitChange={(val: boolean) => {
                    let num = attribute.maxLengthLimit || undefined;
                    if (!val) {
                        num = undefined;
                    }
                    setAttribute({ ...attribute, isLimited: val, maxLengthLimit: num })

                }}
                onNumberChange={(val) => {
                    let num = val || 0;
                    setAttribute({ ...attribute, maxLengthLimit: num });
                }}
                value={attribute.maxLengthLimit}
                isLimited={attribute.isLimited ?? false}
                stepSize={1}
                minVal={1}
            />
        </div>
        <div className={styles.saveField}>
            <Button onClick={() => {
                if (attribute.isLimited && !attribute.maxLengthLimit) {
                    toast.warning("If field has 'Max Length' value of it can't be empty");
                    return;
                }
                props.onFieldSave(attribute)
            }} variant="secondary" text="Save Field" className={styles.saveFieldBtn} />
        </div>
    </div>
}